import {
  mainnetChains,
  mainnetContracts,
  testnetChains,
  testnetContracts,
} from './constants';

export const getWeb3Config = () => {
  const isDev =
    process.env.REACT_APP_NODE_ENV === 'development' ||
    process.env.REACT_APP_NODE_ENV === 'development-local';

  const [chains, contracts] = isDev
    ? [testnetChains, testnetContracts]
    : [mainnetChains, mainnetContracts];

  return { chains, contracts } as const;
};
